// SurveyField contains logic to render single label and text input
import React from 'react';

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => { // its render instide Field from redux form, it has props now
    //console.log(props) // whole props object rom react form Field, handlers
    const { input, label, meta: {error, touched} } = props; // desctructure meta prop 2 levels deep in total
    //console.log(error, touched)
    return (
        <div>
            <label>{label}</label>
            <input {...input} style={{marginBottom: '5px'}}/>
            <div className='red-text' style={{marginBottom: '20px'}}>
                {touched && error}
            </div>
        </div>
    )
}